<template>
    <mu-bottom-nav value="nav1">
        <mu-bottom-nav-item value="nav1" title="nav1" icon="home" />
        <mu-bottom-nav-item value="nav2" title="nav2" icon="favorite" />
        <mu-bottom-nav-item value="nav3" title="nav3" icon="location_on" />
    </mu-bottom-nav>
</template>
<script>
export default {
    name: 'nav'
}
</script>



// WEBPACK FOOTER //
// nav.vue?c960c30e